import React, { Component } from "react";
import styled from "styled-components";
import IconFooter from "../module-common/IconFooter";
import { send, sendWithSession } from "../Socket";
import SendMessage from "../assets/Sending.png";
import moment from "moment";
import { Config } from "../constant";
import { CustomerSendsMedia, CustomerSendsText } from "../model/Outgoing";
import { FileUpload } from './FileUpload'
import { observer } from 'mobx-react'
import { AddDroppedFiles, CommonStore, HasDroppedFiles, IsChatRoomActive, RemoveDroppedFiles, SetTypingTimestamp } from '../Store'
import { toJS } from "mobx";
import FileReady from './FileReady'
import axios from 'axios'
import { debounce } from "lodash";

const maximumFileSize = 1024 * 1024 * 10

export default observer(class MessageInput extends Component {
  constructor(props) {
    super(props);
    this.textChangeHandler = this.textChangeHandler.bind(this);
  }

  state = {
    chatInput: "",
    isTyped: false,
    isActive: false,
    height: "20px",
    uploadProgress: 0
  };

  updateSize = height => {
    this.setState({
      height
    });
  };
  textChangeHandler(event) {
    if (event.target.value.length <= 0) {
      this.setState({
        chatInput: "",
        isTyped: false
      });
    } else {
      
      SetTypingTimestamp()
      this.setState({
        chatInput: event.target.value,
        isTyped: true
      });
    }
  }

  sendMessageToWs = () => {
    const raw = this.state.chatInput
    if(!raw) return
    const trimmed = raw.trim()
    if(!trimmed) return 
    let message = CustomerSendsText(trimmed)
    sendWithSession(message);
    this.setState({ chatInput: "" });
  }

  handleKeyPress = e => {
    if (e.key === "Enter") {      
      this.sendMessageToWs()
    }
  };
  
  onSendMessage = async () => {
    if(HasDroppedFiles()) {
      await this.uploadMedia()
    } else {
      this.sendMessageToWs()
    }
    
  };

  uploadMedia = async () => {
    
    if(HasDroppedFiles()) {
      try {
        const { file } = toJS(CommonStore.droppedFileList)[0]
        const formData = new FormData()
        formData.append('media', file)
        const result = await axios.post(Config.uploadUrl, formData, {
          onUploadProgress: (event) => {
            const { lengthComputable, loaded, total  } = event
            if(lengthComputable && total) {
              const progress = (loaded / total * 100)
              this.setState(state => ({...state, uploadProgress: progress}))
            }
          }
        })
        this.setState(state => ({...state, uploadProgress: 0}))
        const { data } = result
        sendWithSession(CustomerSendsMedia(data.fileName, data.size, data.fileUri, data.contentType))
        RemoveDroppedFiles()
                
      } catch(e) {
        this.setState(state => ({...state, uploadProgress: 0}))
      }
      
    }
  }

  render() {
    const { isTyped, height } = this.state;
    const droppedFileList = toJS(CommonStore.droppedFileList)
    const hasDroppedFiles = droppedFileList.length > 0
    const isChatActive = IsChatRoomActive()
    let newStyle = {
      height
    };
    return (
      <Wrapper>
        <FileUpload
            onChange={(files) => {
              AddDroppedFiles(files)
            }}
            disabled={!isChatActive}
        />
        <MessageInputWrapper>        
          {!hasDroppedFiles && <InputSec
            style={newStyle}
            editable={true}
            multiline={true}
            onChange={this.textChangeHandler}
            value={this.state.chatInput}
            placeholder="Type your message here..."
            onContentSizeChange={e =>
              this.updateSize(e.nativeEvent.contentSize.height)
            }
            onKeyPress={this.handleKeyPress}
            disabled={!isChatActive}
          />}  
          {hasDroppedFiles && (
            <FileReady 
              {...droppedFileList[0]} 
              onClick={() => RemoveDroppedFiles()}
              uploadProgress={this.state.uploadProgress}
            />
          )}
        </MessageInputWrapper>
        <IconWrapper>
          {isTyped ? (
            <IconFooter
              image={SendMessage}
              isSmall={true}
              isActive={true}
              onClick={this.onSendMessage}
            /> // <IconFooter image={Picture} isSmall={true} />
          ) : (
            <IconFooter
              image={SendMessage}
              isSmall={true}
              isActive={false}
              onClick={() => isChatActive && this.onSendMessage()}
            />
          )}
        </IconWrapper>
      </Wrapper>
    );
  }
})

const InputSec = styled.input`
  background-color: transparent;
  overflow: visible;
  width: 100%;
  border: 0px;
  font-size: 11px;
  font-family: "Source Sans Pro", sans-serif;
  font-style: Regular;
  color: #4d4f5c;
  align-self:center;
  &:focus {
    outline: none;
  }
`;


const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-self: center;
  width: 100%;
  height: 40px;
  background: #f5f6fa;
  justify-content: space-between;
  border-top: 1px solid #e7e7e7;
  border-bottom: 1px solid #e7e7e7;
  &:focus-within {
    background: white;
    box-shadow: 0px 0px 12px 2px rgba(0, 0, 0, 0.16);
  }
  ::placeholder {
    color: #a4afb7;
  }
`;
const MessageInputWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin-right: 20px;
  margin-left: 10px;
`;

const IconWrapper = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  align-self: center;
  margin-right: 17px;
`;
